"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUpdateAddressMethodRequest = exports.UpdateAddressSchema = exports.REQUIRED_FIELD_MESSAGE = exports.RESTRICTED_STREET_ADDRESS_TOKENS = void 0;
const yup = __importStar(require("yup"));
const ValidationError_1 = require("../errors/ValidationError");
const AsicAddress_1 = require("./AsicAddress");
const OptionGrant_1 = require("./OptionGrant");
/**
 * Schema for update address method validation
 * {@link IUpdateAddress}
 */
exports.RESTRICTED_STREET_ADDRESS_TOKENS = ["PO Box", "GPO Box", "Locked Bag", "Private Box", "Parcel Locker"];
exports.REQUIRED_FIELD_MESSAGE = "This is a required field.";
const UpdateAddressSchema = yup.object().shape({
    careOf: AsicAddress_1.AsicAddressSchema.careOf.nullable(),
    unitNumber: yup.string().trim().min(0).max(50).ensure(),
    streetName: yup
        .string()
        .trim()
        .required("Please enter Street number & name")
        .min(1)
        .max(52)
        .test("streetName", "Must be a street address", (value) => {
        if (value &&
            exports.RESTRICTED_STREET_ADDRESS_TOKENS.some((token) => value.toLocaleLowerCase().includes(token.toLocaleLowerCase()))) {
            return false;
        }
        return true;
    }),
    suburb: yup.string().trim().required("Please enter City, Town, or Suburb").min(2).max(30),
    state: yup
        .string()
        .trim()
        .when("country", {
        is: "Australia",
        then: yup.string().oneOf(["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"]).required(exports.REQUIRED_FIELD_MESSAGE),
        otherwise: yup.string().max(100),
    }),
    postcode: AsicAddress_1.AsicAddressSchema.postcode,
    country: AsicAddress_1.AsicAddressSchema.country,
    authorisingOfficer: OptionGrant_1.AuthorisingOfficerSchema,
});
exports.UpdateAddressSchema = UpdateAddressSchema;
/**
 * Validates update address method request schema
 * @param data: update address method request data {@link IUpdateAddress} to validate
 */
const validateUpdateAddressMethodRequest = (data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield UpdateAddressSchema.validate(data, {
            abortEarly: false,
        });
        return;
    }
    catch (err) {
        if (err instanceof yup.ValidationError) {
            const errorMessage = err.errors.toString();
            throw new ValidationError_1.ValidationError(errorMessage);
        }
        else {
            throw err;
        }
    }
});
exports.validateUpdateAddressMethodRequest = validateUpdateAddressMethodRequest;
//# sourceMappingURL=UpdateAddress.js.map